import React from 'react';
import Layout from '../components/layout/Layout';
import BranchList from '../components/branches/BranchList';
import BranchModal from '../components/branches/BranchModal';
import { BranchProvider } from '../contexts/BranchContext';

const BranchMastersPage = () => {
  return (
    <Layout>
      <BranchProvider>
        <BranchList />
        
        {/* Modal for creating/editing branches */}
        <BranchModal />
      </BranchProvider>
    </Layout>
  );
};

export default BranchMastersPage;
